webpackJsonp([126955526379009],{

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/human.7e81b65e.jpg";

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(19);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _work = __webpack_require__(25);
	
	var _work2 = _interopRequireDefault(_work);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var human = __webpack_require__(125);
	
	var LivingProduct = function LivingProduct() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Living Product Challenge | Cory Schadt',
	      bodyAttributes: {
	        class: 'inner'
	      }
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: 'page fade' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'content' },
	          _react2.default.createElement(
	            'h1',
	            null,
	            'Living Product Challenge'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'text' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'The Living Product Challenge calls on manufacturers to make their own operations Net Positive with respect to impact categories such as water, energy, climate, waste and ecological impacts.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'This site was created to highlight products which meet the Living Product Certification.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Primary Role:  HTML, CSS, Responsive Design, CSS Animations.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'a',
	                { className: 'btn', target: '_blank', href: 'https://ca.humanscale.com/about/living-product-challenge/index.cfm' },
	                'View Project'
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'project-feature' },
	        _react2.default.createElement(_work2.default, { noLink: true, raise: true, laptop: true, screen: human, color: '#62E3AC' })
	      )
	    )
	  );
	};
	exports.default = LivingProduct;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-living-product-js-edde33b0f67e119ae320.js